<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">สงวนลิขสิทธิ์ พ.ศ.2562-2566 ©</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">Thailand Festival</div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
